module.exports = __webpack_public_path__ + "img/cart.95ea0222.svg";